

import __layout_0 from '/var/www/html/resources/ts/layouts/default.vue'
export const layouts = {
'admin': () => import('/var/www/html/resources/ts/layouts/admin.vue'),
'blank': () => import('/var/www/html/resources/ts/layouts/blank.vue'),
'default': __layout_0,
'front': () => import('/var/www/html/resources/ts/layouts/front.vue'),
'components/AdminLayoutWithVerticalNav': () => import('/var/www/html/resources/ts/layouts/components/AdminLayoutWithVerticalNav.vue'),
'components/DefaultLayoutWithHorizontalNav': () => import('/var/www/html/resources/ts/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithNoNav': () => import('/var/www/html/resources/ts/layouts/components/DefaultLayoutWithNoNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/var/www/html/resources/ts/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/var/www/html/resources/ts/layouts/components/Footer.vue'),
'components/NavBarNotifications': () => import('/var/www/html/resources/ts/layouts/components/NavBarNotifications.vue'),
'components/NavbarShortcuts': () => import('/var/www/html/resources/ts/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/var/www/html/resources/ts/layouts/components/NavbarThemeSwitcher.vue'),
'components/UserProfile': () => import('/var/www/html/resources/ts/layouts/components/UserProfile.vue'),
'components/Admin/UserProfile': () => import('/var/www/html/resources/ts/layouts/components/Admin/UserProfile.vue'),
}
export const createGetRoutes = (router, withLayout = false) => {
  const routes = router.getRoutes()
  if (withLayout) {
      return routes
  }
  return () => routes.filter(route => !route.meta.isLayout)
}

export function setupLayouts(routes) {
  function deepSetupLayout(routes, top = true) {
    return routes.map(route => {
      if (route.children?.length > 0) {
        route.children = deepSetupLayout(route.children, false)
      }
      
      if (top) {
        // unplugin-vue-router adds a top-level route to the routing group, which we should skip.
        const skipLayout = !route.component && route.children?.find(r => (r.path === '' || r.path === '/') && r.meta?.isLayout)  

        if (skipLayout) {
          return route
        }

        if (route.meta?.layout !== false) {
          return { 
            path: route.path,
            component: layouts[route.meta?.layout || 'default'],
            children: route.path === '/' ? [route] : [{...route, path: ''}],
            meta: {
              isLayout: true
            }
          }
        }
      }

      if (route.meta?.layout) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      return route
    })
  }

    return deepSetupLayout(routes)

}
